import { render, staticRenderFns } from "./DataLevel.vue?vue&type=template&id=50714fb4&scoped=true"
import script from "./DataLevel.vue?vue&type=script&lang=js"
export * from "./DataLevel.vue?vue&type=script&lang=js"
import style0 from "./DataLevel.vue?vue&type=style&index=0&id=50714fb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50714fb4",
  null
  
)

export default component.exports